import React, { useRef } from "react";
import SignatureCanvas from "react-signature-canvas"; // Assuming you're using react-signature-canvas

const Signature = React.forwardRef((props, ref) => {
  const sigCanvas = useRef({});

  // Method to clear the signature
  const clearSignature = () => {
    sigCanvas.current.clear();
  };

  // Method to get signature data
  const getSignatureData = () => {
    if (sigCanvas.current.isEmpty()) {
      return null; // No signature provided
    }
    return sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"); // Get the image as a Base64 string
  };

  // Expose methods to parent using ref
  React.useImperativeHandle(ref, () => ({
    clearSignature,
    getSignatureData,
  }));

  return (
    <div>
      <SignatureCanvas
        ref={sigCanvas}
        penColor='black'
        canvasProps={{ width: 250, height: 70, className: "sigCanvas" }} // Reduced size
      />
    </div>
  );
});

export default Signature;
